<template>
  <div class="gallery">
    <div class="thumbnails">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="thumb"
        @click="activeIndex = index"
        :class="{ active: activeIndex == index }"
      >
        <img :src="image" alt="">
      </div>
    </div>
    <div class="main-image" @click="showingLightbox = true">
      <img :src="activeImage" alt="">
      <img src="/images/zoom.svg" alt="" class="zoom">
    </div>
    <vue-easy-lightbox
      :visible="showingLightbox"
      :imgs="images"
      :index="activeIndex"
      @hide="showingLightbox = false"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      activeIndex: 0,
      showingLightbox: false,
    }
  },

  computed: {
    activeImage () {
      return this.images[this.activeIndex]
    },
  },
}
</script>